module.exports = __webpack_public_path__ + "img/social-media-display-lincoln.a577d8d4.png";